export const LOG_LEVELS = {
  LOG: 'log',
  INFO: 'info',
  WARN: 'warning',
  ERROR: 'error',
  FATAL: 'fatal',
  DEBUG: 'debug',
} as const;
